import React from 'react';
import PropTypes from 'prop-types';
import styles from './MultimediaDisplay.scss';

class MultimediaPlaceholderDisplay extends React.PureComponent {
    static propTypes = {
        model: PropTypes.object.isRequired,
        reportReady: PropTypes.func,
    };

    static defaultProps = {
        reportReady: () => undefined,
    };

    componentDidMount() {
        this.props.reportReady(true);
    }

    render() {
        const { model } = this.props;
        return (
            <div>
                {
                    prompt && prompt.length ? <p className={styles.mediaPrompt}>{prompt}</p> : null
                }
                <div className={`${styles['ia-multimedia-wrapper']} ${model.objectClass}`}>
                    <div ref={(multimedia) => { this.multimedia = multimedia; }} />
                    {
                        model.type === 'video' ?
                            <div className="video-placeholder">
                                <i className="fa fa-play" aria-hidden="true" />
                            </div>
                            :
                            null
                    }
                    <div className="ia-multimediaplayer-controls">
                        <button className="play playerButton disabled" disabled>
                            <i className="fa fa-play" />
                        </button>
                        <div className="volume playerButton">
                            <div className="volumeIcons">
                                <i className="fa fa-volume-up fa-2x" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MultimediaPlaceholderDisplay;
